<template>
    <div class="log" :style="dynamicStyle" v-on:click="editEvent(event.id)" :title=" infos ">
        <span > {{event.project_name}}{{ comment }} [{{event.duration}}] </span>
    </div>

</template>
<script>
    import {
        colorsEvent, colorsLeave
    } from "../../settings.js";
    export default {
        name: "Event",
        debug: false,
        props: ['event','nbEvent','idToColor','maxDuration'],
        data() {
            return {
                comment: (this.event.comment) ? " : "+this.event.comment : ""
            }
        },
        computed: {
            dynamicStyle: function() {
                var percent = 12.3;
                if(this.nbEvent){
                    if(this.nbEvent > 0 && this.nbEvent <9){
                        var splitTime = this.event.duration.split(":");
                        var minutes = Number(splitTime[1]) + (Number(splitTime[0])*60);
                        percent = ((minutes * 100)/this.maxDuration)-0.3; 
                    }    
                }
                if(this.event.ref == "APRARRMAL" || this.event.ref == "APRCONG" || this.event.ref == "APRCONGOFF"){
                    var nbColorsL = colorsLeave.length;
                    return {
                        background: colorsLeave[this.idToColor.indexOf(this.event.project_id) % nbColorsL],
                        width: percent+'%',
                    }
                }else{
                    var nbColorsE = colorsEvent.length;
                    return {
                        background: colorsEvent[this.idToColor.indexOf(this.event.project_id) % nbColorsE],
                        width: percent+'%',
                    }
                }
            },
            infos: function(){
                return this.event.duration +" "+ this.event.project_name +" / "+ this.event.client_name + this.comment;
            }
        },
        methods: {
            editEvent: function() {
                this.$emit('toggleEdit', this.event);
            },
            
        },
    }
</script>

<style scoped>
    .log {
        display: inline-block;
        margin-right: 0.3%;
        margin-top: 0.1em;
        padding: 0.1em;
        border: solid black 1px;
        max-width: 100%;
    }

    span {
        display: inline-block;
        margin: 0;
        padding: 0;
        width: 100%;
        vertical-align: bottom;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .log:hover {
        cursor: pointer;
    }
</style>